<template>
  <div class="login">
    <div class="logo">
      <img src="../assets/img/logo.png">
    </div>
    <div class="login-area">
      <div class="account-area">
        <i class="iconfont icon-yonghu"></i>
        <input type="text" placeholder="请输入你的账号" v-model="userid">
      </div>
      <div class="account-area">
        <i class="iconfont icon-mima"></i>
        <input type="password" placeholder="请输入密码" v-model="passwd">
      </div>
      <p class="login-btn" @click="localLogin">登 录</p>
    </div>
    <div class="footer-wrapper">
      <div class="footer">Copyright © {{ new Date().getFullYear() }} 江苏汇文软件有限公司</div>
    </div>
  </div>
</template>

<script>
import {defineComponent, ref} from "vue";
import {login} from '../api/sys';
import {getCartNum} from '../api/users';
import {isNotEmpty} from '../utils/util';
import { Toast } from 'vant';
import store from '@/store';
import router from '../router';

export default defineComponent({
  name: 'Login',
	setup() {
		const userid = ref('');
		const passwd = ref('');
    const localLogin = () => {
        if(isNotEmpty(userid.value) && isNotEmpty(passwd.value)){
            let param = new URLSearchParams();
            param.append('userid',  userid.value);
            param.append('passwd',  passwd.value);
            login(param)
                .then(resp=> {
                    if(resp.code === 1){
                        Toast({message: resp.msg});
                    }else if(resp){
                        store.commit('setUser', resp);
                        onCartNum();
                        router.push({path: '/personalCenter'});
                        Toast({message: '登录成功'});
                    }
                })
                .catch((error) => {
                    console.error(error);
                });
        }else {
            Toast({message: '请输入账号和密码'});
        }
    };
    const onCartNum = () => {
        getCartNum()
            .then(data => {
                store.commit('setCartNum', data);
            })
            .catch((error) => {
                console.error(error);
            });
    };
    return {
        userid,
        passwd,
        localLogin,
        onCartNum
    }
	},
})
</script>

<style scoped lang="less">
@import "../assets/css/login.less";
</style>
